import React from "react";
import CustomImage from "./CustomImage";
import format from "date-fns/format";
import { formatOrder } from "../utils/constants";

interface RelatedBlogsProps {
  categoryBlogs: any[];
  pathCondition: boolean;
  detailData: any;
  styles: any;
}

const RelatedBlogs: React.FC<RelatedBlogsProps> = ({ 
  categoryBlogs, 
  pathCondition, 
  detailData, 
  styles 
}) => {
  if (pathCondition || categoryBlogs.length === 0) {
    return null;
  }

  return (
    <div className={styles.new}>
      <div>
        <h2 className={styles.headingBlogs}>Related Blogs</h2>
        {categoryBlogs.map((blog: any, index: number) => {
          return (
            <div
              className={`${styles.allnews} ${styles.relatedBlogsBox}`}
              key={index}
            >
              {blog.newimageUrl && (
                <a
                  href={
                    detailData.isExternalLink && detailData.externalLink
                      ? detailData.externalLink
                      : `/${pathCondition ? "news" : "blogs"}/${blog.slug}`
                  }
                >
                  <div className={styles.card}>
                    <div className={styles.relatedBlogImg}>
                      <CustomImage
                        src={blog.newimageUrl?.imageUrl}
                        alt={blog.newimageUrl?.alt}
                        width={370}
                        height={155}
                        object-fit="fill"
                        layout="responsive"
                      />
                    </div>

                    <div className={styles.cardBody}>
                      {blog.category && (
                        <h6 className={styles.blogsCategories}>
                          {blog.category}
                        </h6>
                      )}
                      <h5>{blog.title}</h5>
                      {blog.shortDescription && (
                        <p className={styles.shortDescription}>
                          {blog.shortDescription}
                        </p>
                      )}
                      <span>
                        {format(new Date(blog.date), formatOrder)}
                      </span>
                    </div>
                  </div>
                </a>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RelatedBlogs; 